module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_is-object.js
// module id = 16
// module chunks = 0